import Vue from 'vue'
import App from './App.vue'

/* Inizio ElementUI */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/it'
Vue.use(ElementUI, { locale })
/* Fine ElementUI */
        

/* Inizio TerAs */
var vueData = {}
import VueMoment from './teras/vue-moment'
Vue.use(VueMoment,'it')
import teras from './teras'
Vue.prototype.$teras = teras
vueData.teras = teras
import axios from './teras/tAxios'
Vue.prototype.$axios = axios
vueData.axios = axios

import './css/big.css'
/* Fine TerAs */
        

/* Inizio Router */
import router from'./router'
/* Fine Router */
        

/* Inizio Storage */
import storage from './teras/tStorage' 
Vue.prototype.$storage = storage
vueData.storage = storage
/* Fine Storage */
        
Vue.config.productionTip = false

/* Inizio TerAs-event */
teras.event.on('routerFirst', function(to) {
  axios.query('fetchAll',`SELECT * FROM codicefiscale.comune WHERE 1 ORDER BY nome`,{},teras,'_comune')  
  axios.query('fetchAll',`SELECT * FROM codicefiscale.provincia WHERE 1 ORDER BY nome`,{},teras,'_provincia')  
  axios.query('fetchAll',`SELECT id,regione AS nome FROM codicefiscale.provincia WHERE regione!='' GROUP BY regione ORDER BY regione`,{},teras,'_regione')  
  axios.query('fetchAll',`SELECT * FROM bm_bvent.nazione WHERE 1 ORDER BY id`,{},teras,'_nazione')
  axios.query('fetchAll',`SELECT * FROM societa WHERE 1 ORDER BY peso,id`,{},teras,'_societa')
  axios.query('fetchAll',`SELECT * FROM bm_limmsy_2018.tiposocio WHERE 1 ORDER BY id`,{},teras,'_tiposocio').then((response) =>  {
    teras.app.step++
  })

/* Inizio teras-login */
  console.log("CONTROLLO SE PRESENTE UTENTE IN LOCAL STORAGE....")
  if(storage.exist('utente')){
    console.log("YES, PRESENTE UTENTE IN LOCAL STORAGE....LO RICARICO DA LI..."+to.path)
    teras.utente = storage.load('utente')
    teras.app.routeInitial = to.path
    teras.event.emit('login')
  }else{
      console.log("Aggiungo +1 per il controllo del utente")
      teras.app.step++
      teras.app.routeInitial = (to.matched.some(record => record.meta.requiresAuth)) ? '/login' : to.path //+url.search
  }
/* Fine teras-login */
        
})
teras.event.on('appReady', function() {
console.log("appReady appReady appReady appReady appReady appReady appReady")
router.push(teras.app.routeInitial)
})
teras.event.on('appExit', function() {
})
/* Fine TerAs-event */

/* Inizio TerAs-event-login */
teras.event.on('routerNoauth', function() {
})
teras.event.on('login', async function () {
  teras.app.auth = true
  storage.save("utente",teras.utente)
  await socio.contatto.load(teras.utente.id)
  console.log("Aggiungo +1 per il controllo del utente")
  teras.app.step++
  if(teras.app.ready){
    console.log("APPREADYFROM LOGIN "+teras.app.routeInitial)
    router.push(teras.app.routeInitial)
  }
  
})
teras.event.on('logout', function() {
  teras.utente = {}
  storage.remove('utente')
  teras.app.auth = false
  router.replace('/login')
})
/* Fine TerAs-event-login */
        
import socio from './teras/socio'
Vue.prototype.$socio = socio
vueData.socio = socio                  

new Vue({
  router,
  data:vueData,
  render: h => h(App)
}).$mount('#app')
